import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Box, Button, useTheme } from '@mui/material';
import ObjectPicker from "../partials/pickers/ObjectPicker";
import { BoxContainer } from '../layouts/Theme';
import useWidgetStore from '../store/useWidgetStore';
import { useForm } from 'react-hook-form';
import useDataStore from '../store/useDataStore';
import { Fragment, useEffect, useState } from 'react';
import { FormContainer } from 'react-hook-form-mui';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
import ObjectGroupedCategoryPicker from '../partials/pickers/ObjectGroupedCategoryPicker';
import { useSettings } from '../context/SettingsContext';
export default function CrossSelling(props) {
    const theme = useTheme();
    const { t } = useI18N();
    const { enabled, setEnabled, } = useWidgetStore();
    const { products, categories, getProduct } = useDataStore();
    const { hasShop, hasGroupedShop } = useSettings();
    const [data, setData] = useState([]);
    const flow = useFlow();
    useEffect(() => {
        if (!enabled.product) {
            setEnabled(Object.assign(Object.assign({}, enabled), { product: true }));
        }
        if (!enabled.category) {
            setEnabled(Object.assign(Object.assign({}, enabled), { category: true }));
        }
    }, []);
    useEffect(() => {
        if (products) {
            let _data = products.filter((product) => !product.requiredApp && product.status === "enabled");
            setData(_data);
        }
    }, [products]);
    // useEffect(() => {
    //     if(flow.currentRoute?.route === "crossSelling") {
    //         if(data.length === 0) {
    //             console.log(flow, flow.direction, flow.fromRoute)
    //         }
    //     }
    // }, [flow.previousRoute])
    const formContext = useForm({});
    const onSubmit = (data, event) => {
        // form does nothing, is just here to provide a context for the pickers inside
        // @ts-ignore
        flow === null || flow === void 0 ? void 0 : flow.onNext();
    };
    const onError = (errors) => { };
    return (_jsx(_Fragment, { children: _jsx(BoxContainer, { sx: Object.assign({ padding: 0 }, (!hasGroupedShop && {
                paddingBottom: 4
            })), children: _jsx(FormContainer, { formContext: formContext, onSuccess: onSubmit, onError: onError, children: _jsxs(Fragment, { children: [data.length > 0 && products && !hasGroupedShop && (_jsx(Box, { sx: { marginY: 4 }, children: _jsx(ObjectPicker, { source: "product", data: data, config: {
                                    toDetail: false,
                                    action: "purchase", // this should be purchase but this throws a hook queue issue I can't figure out, and my sourcemap broke too for some reason
                                    types: ["product", "giftcard", "membership", "subcscription"],
                                } }) })), categories && hasGroupedShop && (_jsx(ObjectGroupedCategoryPicker, { source: "category", data: categories, config: {} })), _jsx(Box, { sx: {
                                position: 'absolute',
                                bottom: '0',
                                borderColor: theme.palette.divider,
                                borderWidth: '1px 0 1px 0',
                                borderStyle: "solid",
                                left: '-16px',
                                width: 'calc(100% - 32px)',
                                paddingX: '32px',
                                backgroundColor: theme.palette.background.paper,
                                zIndex: 1000
                            }, children: _jsx(Button, { type: "submit", fullWidth: true, sx: {
                                    my: '16px'
                                }, variant: "contained", children: t("Volgende stap") }) })] }) }) }) }));
}
